import styled from 'styled-components';
export const SectionContainer = styled.section `
  padding: 60px 20px;
  background: #f8fafc;
  width: 100%;
`;
export const Container = styled.div `
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 0 20px;
`;
export const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 4rem;
`;
export const SectionTitle = styled.h2 `
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  position: relative;
  display: inline-block;
  margin: 0;
  color: #1a1a1a;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #ffd700;
    border-radius: 2px;
  }
`;
export const Grid = styled.div `
  width: 100%;
  margin: 0 auto;
`;
export const Content = styled.div `
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  padding: 20px 0;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #e5e7eb;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ffd700;
    border-radius: 4px;

    &:hover {
      background: #fdb927;
    }
  }
`;
export const Card = styled.div `
  background: #ffffff;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  border: 1px solid #f3f4f6;
  overflow: hidden;
  min-width: 320px;
  width: 320px;
  flex-shrink: 0;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    width: 280px;
    min-width: 280px;
    padding: 1.5rem;
  }
`;
export const Tag = styled.span `
  display: inline-block;
  background: #ffd700;
  color: #1a1a1a;
  padding: 0.35rem 0.85rem;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
`;
export const CardTitle = styled.h3 `
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  color: #1a1a1a;
  font-weight: 600;
`;
export const Excerpt = styled.p `
  color: #6b7280;
  margin-bottom: 1rem;
  font-size: 0.9375rem;
  line-height: 1.6;
`;
export const BlogMeta = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  color: #6b7280;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
export const BlogLink = styled.a `
  color: #ffd700;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &::after {
    content: ' →';
  }

  &:hover {
    text-decoration: underline;
  }
`;
